import { AppleButton } from "./apple-button.tsx";
import { GoogleButton } from "./google-button.tsx";
import { SocialButtonsProps } from "./social-buttons-props.ts";

const GroupedSocialButtons: React.FC<SocialButtonsProps> = ({ onAuthSuccess }) => {
  return (
    <div>
      <div className="flex gap-x-3 w-full">
        <GoogleButton onAuthSuccess={onAuthSuccess} />
        <AppleButton onAuthSuccess={onAuthSuccess} />
      </div>
    </div>
  );
};

export default GroupedSocialButtons;
